<template>
	<div class="limit-des">
        <section>
            <popup v-model="ctrl" position="bottom" :closeOnClickModal="true" class="main">
                <div>
                    <div class="title">进出口件禁止/限制寄递物品<span class="close" @click="close"></span></div>
                    <div class="content-box">
                        <div class="content">
                            <p class="no-margin">我们不寄递/有条件寄递下列物品：</p>
                            <ul>
                                <li>武器、仿真武器、弹药、管制器具及爆炸物品</li>
                                <li>易燃烧性物品、易爆炸性物品</li>
                                <li>氧化剂和过氧化物</li>
                                <li>毒品及吸毒工具、非正当用途麻醉药品和精神药品、非正当用途的易制毒化学品、毒性物质</li>
                                <li>生化制品、传染性、感染性物质</li>
                                <li>腐蚀性物质、放射性物质</li>
                                <li>伪造或者变造的货币、有价证券、证件、公章等非法伪造物品</li>
                                <li>货币和有价证券</li>
                                <li>侵犯知识产权和假冒伪劣物品</li>
                                <li>动植物尤其各类濒危野生动物植物及其制品</li>
                                <li>如有碍人畜健康的、来自疫区的以及其他能传播疾病的食品、药品或者其他物品</li>
                                <li>烟草和烟草制品、酒</li>
                                <li>贵重物品（例如，艺术品、古董、宝石以及黄金等贵重金属）</li>
                                <li>其他法律法规的违禁品</li>
                            </ul>
                            <p>除以上禁寄/限寄物品外，顺丰还有权拒绝寄递和/或暂停寄递以下物品：</p>
                            <ul>
                                <li>任何未提供寄件人和收件人的详细联络信息的包裹；</li>
                                <li>在我们看来不适合寄递或未用适合寄递的方式恰当地描述、分类或包装和加标签并具备必要凭证的物品；</li>
                                <li>因产品本身或包装特性，我们基于自身判断认为可能危及运输工具及人员安全的物品；</li>
                                <li>我们基于自身判断认为从经济角度或操作角度不可寄递的物品。</li>
                            </ul>
                        </div>
                        <p class="law">遵守起始国家/地区及目的国家/地区当前适用的法律法规及政府规定是寄件人的义务，因各个国家/地区规定禁止或限制寄递的物品不尽相同，除以上禁寄/限寄物品标准外，建议寄件人还需参考物品寄递起始国家/地区和目的国家/地区的进出口禁寄/限寄物品列表</p>
                        <div class="tips">
                            <span class="red">温馨提示：</span>
                            <span class="gray">我司已对“进出口件”收寄标准查询做如上调整，如您对您寄递的物品是否属于“禁寄/限寄”物品有疑问，可联系顺丰客服
                                <a class="red" :href="'tel:' + onLineNo">{{ onLineNo }}</a> 或点击
                                <a class="red" :href="acceptOnLineUrl">在线客服</a>咨询。
                            </span>
                        </div>
                    </div>
                </div>
            </popup>
        </section>
	</div>
</template>

<script>

import { Popup } from "mint-ui";

export default {
	name: "limitDes",
	components: {
		"popup": Popup,
	},
	props: {
		show: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
            ctrl: this.show,
            acceptOnLineUrl:window._webconfig.acceptOnLineUrl,
			onLineNo:window._webconfig.onLineNo
		}
	},
	computed: {
    },
	created() {
	},
    mounted() {},
    destroyed() {
    },
	methods: {
        close() {
            this.ctrl = false
        }
	},
	watch: {
        show(val, old) {
            if(val !== old) {
                this.ctrl = val
            }
        },
        ctrl(val, old) {
            if(val !== old) {
                if(!val) this.$emit('close')
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.limit-des {
	.main {
        width: 100vw;
        padding: .34rem .48rem;
        height: 92%;
        box-shadow: 0 8px 32px 0 rgba(0,0,0,0.30);
        border-radius: .08rem .08rem 0 0;
        padding: .34rem .48rem;
        overflow: hidden auto;
        .content-box {
            height: calc(100vh - 2.1rem);
            overflow: hidden auto;
        }
        .no-margin {
            margin-top: 0;
        }
        .title {
            font-size: .32rem;
            color: #333333;
            position: relative;
            font-weight: bold;
            margin-bottom: .3rem;
            .close {
                position: absolute;
                top: 50%;
                margin-top: -.24rem;
                right: 0;
                display: inline-block;
                width: .48rem;
                height: .48rem;
                background-image: url('~@/assets/images/recStandard/icon-close-popup.png');
                background-repeat: no-repeat;
                background-position: center;
                background-size: .48rem;
            }
        }
         p {
                font-size: .28rem;
                color: #333333;
                margin-top: .3rem;
                font-weight: bold;
            }
        .content {
            ul {
                li {
                    font-size: .26rem;
                    color: #2A2A2A;
                    text-align: justify;
                    line-height: .39rem;
                }
            }
        }
        .tips {
            font-size: .28rem;
            color: #333333;
            margin-top: .3rem;
            line-height: .39rem;
            .red {
                color: #DC1E32;
            }
            .gray {
                color: #2a2a2a;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/recStandard/components/limit-des.vue